module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/no_games_baseball-5e9c9cf152fa7a277a7c20f4afd1736f.svg";